module.exports = __webpack_public_path__ + "img/session_expired_clock.c06ac59b.svg";